export default "__VITE_ASSET__CP6m8die__"